(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    const CART_NOTE_SELECTOR = 'textarea[name="note"]';

  document.addEventListener('input', function (event) {
    const textarea = event.target;
    if (!textarea.matches(CART_NOTE_SELECTOR)) return;

    document.querySelectorAll(CART_NOTE_SELECTOR).forEach(function (other) {
      if (other !== textarea && other.value !== textarea.value) {
        other.value = textarea.value;
      }
    });
  });

  document.addEventListener('focusout', function (event) {
    const textarea = event.target;
    if (!textarea.matches(CART_NOTE_SELECTOR)) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: textarea.value }),
    }).catch(function () {});
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-grid-selector"] && !Shopify.designMode) return;
  try {
    class CollectionGridSelector extends HTMLElement {
    constructor() {
      super();
      this.mobileButtons = this.querySelectorAll('[data-device="mobile"]');
      this.desktopButtons = this.querySelectorAll('[data-device="desktop"]');
      this.sectionId = this.dataset.sectionId;
      this.init();
    }

    init() {
      const savedMobileColumns = sessionStorage.getItem(`collection-grid-columns-mobile-${this.sectionId}`);
      const savedDesktopColumns = sessionStorage.getItem(`collection-grid-columns-desktop-${this.sectionId}`);

      if (savedMobileColumns) {
        this.setColumns('mobile', parseInt(savedMobileColumns, 10));
      } else {
        this.setColumns('mobile', 2);
      }

      if (savedDesktopColumns) {
        this.setColumns('desktop', parseInt(savedDesktopColumns, 10));
      } else {
        this.setColumns('desktop', 4);
      }

      for (const button of this.mobileButtons) {
        button.addEventListener('click', () => {
          const columns = parseInt(button.dataset.columns, 10);
          this.setColumns('mobile', columns);
          sessionStorage.setItem(`collection-grid-columns-mobile-${this.sectionId}`, columns);
        });
      }

      for (const button of this.desktopButtons) {
        button.addEventListener('click', () => {
          const columns = parseInt(button.dataset.columns, 10);
          this.setColumns('desktop', columns);
          sessionStorage.setItem(`collection-grid-columns-desktop-${this.sectionId}`, columns);
        });
      }
    }

    setColumns(device, columns) {
      const section = document.getElementById(`Collection-${this.sectionId}`);
      if (!section) return;

      if (device === 'mobile') {
        section.style.setProperty('--collection-columns-mobile', columns);

        for (const btn of this.mobileButtons) {
          const isActive = parseInt(btn.dataset.columns, 10) === columns;
          btn.classList.toggle('collection-grid-selector__option--active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      } else {
        section.style.setProperty('--collection-grid-columns', columns);

        for (const btn of this.desktopButtons) {
          const isActive = parseInt(btn.dataset.columns, 10) === columns;
          btn.classList.toggle('collection-grid-selector__option--active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      }
    }
  }

  if (!customElements.get('collection-grid-selector')) {
    customElements.define('collection-grid-selector', CollectionGridSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["faq-category"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faq-category')) {
    class FaqCategory extends HTMLElement {
      #BREAKPOINT = 990;

      connectedCallback() {
        this.#applyDefaultOpen();
      }

      #applyDefaultOpen() {
        const defaultAccordion = this.querySelector('[data-default-open]');
        if (!defaultAccordion) return;

        defaultAccordion.setAttribute('open', '');
      }
    }

    customElements.define('faq-category', FaqCategory);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-size-guide"] && !Shopify.designMode) return;
  try {
    class SizeGuideTabs extends HTMLElement {
  constructor() {
    super();
    this.tabList = this.querySelector('[role="tablist"]');
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');
    
    this.init();
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => this.handleTabClick(e));
      tab.addEventListener('keydown', (e) => this.handleTabKeydown(e));
    });
  }

  handleTabClick(event) {
    const clickedTab = event.currentTarget;
    this.switchTab(clickedTab);
  }

  handleTabKeydown(event) {
    const currentIndex = Array.from(this.tabs).indexOf(event.currentTarget);
    let targetTab = null;

    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        targetTab = this.tabs[currentIndex - 1] || this.tabs[this.tabs.length - 1];
        break;
      case 'ArrowRight':
        event.preventDefault();
        targetTab = this.tabs[currentIndex + 1] || this.tabs[0];
        break;
      case 'Home':
        event.preventDefault();
        targetTab = this.tabs[0];
        break;
      case 'End':
        event.preventDefault();
        targetTab = this.tabs[this.tabs.length - 1];
        break;
      default:
        return;
    }

    if (targetTab) {
      this.switchTab(targetTab);
      targetTab.focus();
    }
  }

  switchTab(newTab) {
    const newPanelId = newTab.getAttribute('aria-controls');
    const newPanel = this.querySelector(`#${newPanelId}`);

    this.tabs.forEach(tab => {
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    });

    this.panels.forEach(panel => {
      panel.hidden = true;
    });

    newTab.setAttribute('aria-selected', 'true');
    newTab.setAttribute('tabindex', '0');
    newPanel.hidden = false;
  }
}

if (!customElements.get('size-guide-tabs')) {
  customElements.define('size-guide-tabs', SizeGuideTabs);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["resource-list"] && !Shopify.designMode) return;
  try {
    (function () {
    const sliders = document.querySelectorAll('.resource-list__slider');

    function updateContainScroll() {
      sliders.forEach((slider) => {
        const hasPeekMobile = slider.classList.contains('resource-list__slider--peek-mobile');
        const hasPeekTablet = slider.classList.contains('resource-list__slider--peek-tablet');
        const hasPeekDesktop = slider.classList.contains('resource-list__slider--peek-desktop');

        let containScroll = 'trimSnaps';

        // Check current breakpoint and apply appropriate contain-scroll
        if (window.matchMedia('(max-width: 749px)').matches && hasPeekMobile) {
          containScroll = 'keepSnaps';
        } else if (window.matchMedia('(min-width: 750px) and (max-width: 989px)').matches && hasPeekTablet) {
          containScroll = 'keepSnaps';
        } else if (window.matchMedia('(min-width: 990px)').matches && hasPeekDesktop) {
          containScroll = 'keepSnaps';
        }

        slider.setAttribute('contain-scroll', containScroll);
      });
    }

    // Update on load
    updateContainScroll();

    // Update on resize
    const mediaQueries = [
      window.matchMedia('(max-width: 749px)'),
      window.matchMedia('(min-width: 750px) and (max-width: 989px)'),
      window.matchMedia('(min-width: 990px)'),
    ];

    mediaQueries.forEach((mq) => {
      mq.addEventListener('change', updateContainScroll);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
